import Card from "../../../../../components/layouts/card/card";
import PolicyStore from "../../../stores/policy-store";
import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import ConditionGroupCard from "./condition-group-card/condition-group-card";
import { CONDITION_GROUP_LEVELS } from "../../../policy-types";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { APPLY_ON, RESOLUTION_TYPES_SUPPORTING_GIFT_RETURNS_ELIGIBILITY, applyOnOptionsList } from "../../../constants";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import currentPortalStore from "../../../../../stores/current-portal-store";
import GridLineLayout from "../../../../../components/layouts/grid-line-layout/grid-line-layout";
import { ExpandCallapseStore } from "../../../../../hooks/expand-collapse-hook";

interface IProps {
    policy: PolicyStore;
    expandCollapseStore: ExpandCallapseStore;
}

const PolicyEligibilityCard: React.FC<IProps> = observer(({ policy, expandCollapseStore }) => {
    const level_list = [
        CONDITION_GROUP_LEVELS.ORDER,
        CONDITION_GROUP_LEVELS.CUSTOMER,
        CONDITION_GROUP_LEVELS.ITEM,
        CONDITION_GROUP_LEVELS.RMA
    ];

    const applyOnSelected = applyOnOptionsList().find(v => v.value === policy.applyOn);
    const giftReturnsEnabled = !!currentPortalStore.setting?.enableGiftReturns;
    const showApplyOn = giftReturnsEnabled && policy.selectedResolutionType !== undefined && RESOLUTION_TYPES_SUPPORTING_GIFT_RETURNS_ELIGIBILITY.includes(policy.selectedResolutionType);

    return (
        <Card 
            toolbar={{ title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Eligibility</FontBody1> }}
            isExpanded={expandCollapseStore.getIsExpanded('eligibility-card')}
            expandCallback={(v) => expandCollapseStore.setExpanded('eligibility-card', v)}
        >
            <FontBody2>Specify the conditions under which this policy rule will be offered to customers.</FontBody2>

            {!!showApplyOn && 
                <FormFieldLine label="Apply this policy rule on" note="Set in which return scenarios to apply this policy rule">
                    <SelectDropdown 
                        value={applyOnSelected}
                        options={applyOnOptionsList()}
                        onChange={(v) => policy.setApplyOn(v?.value as APPLY_ON)}
                        isSearchable={false}
                    />
                </FormFieldLine>
            }

            <GridLineLayout>
            {level_list.map((level, index) => {
                if (policy.isGroupEnabled(level)) {
                    return (
                        <ConditionGroupCard
                            key={index}
                            policy={policy}
                            level={level}
                        />
                    )
                }

                return null;
            })}
            </GridLineLayout>
        </Card>
    )
});

export default PolicyEligibilityCard;
